import i18n from "@/libs/i18n";
export default [
  {
    get header() {
      return i18n.t("operation.admin-page");
    },
    permission: "get-user",
    role: "AdminPage",
  },
  {
    get title() {
      return i18n.t("common.reports");
    },
    icon: "FileIcon",
    route: "reports",
    permission: "get-permission",
    role: "AdminPage",
  },
  {
    get title() {
      return i18n.t("operation.users");
    },
    icon: "UsersIcon",
    route: "users",
    permission: "get-user",
    role: "AdminPage",
  },
  {
    get title() {
      return i18n.t("operation.cities");
    },
    icon: "HomeIcon",
    route: "city",
    permission: "get-city",
    role: "AdminPage",
  },
  {
    get title() {
      return i18n.t("operation.governorates");
    },
    icon: "HomeIcon",
    route: "governorate",
    permission: "get-governorate",
    role: "AdminPage",
  },

  {
    get title() {
      return i18n.t("operation.roles");
    },
    icon: "ShieldIcon",
    route: "operations-roles",
    permission: "get-role",
    role: "AdminPage",
  },

  // {
  //   get title() {
  //     return i18n.t("operation.exchange-rate");
  //   },
  //   icon: "ShieldIcon",
  //   route: "exchange-rate",
  //   permission: "get-ivf-exchange-rate",
  //   role: "AdminPage",
  // },
  {
    get title() {
      return i18n.t("operation.permissions");
    },
    icon: "EyeIcon",
    route: "operations-permissions",
    permission: "get-permission",
    role: "AdminPage",
  },
];
